import { useEffect } from 'react';

// Controla el auto-scroll de las cards de juegos.
// Solo se habilita cuando `isDesktop` es true y la organización es 12.
export function useAutoScrollGames(rowJuegosRef, isDesktop) {
  useEffect(() => {
    if (!isDesktop || !["12", "42"].includes(process.env.REACT_APP_COD_ORGANIZACION)) return;

    let animationFrameId;
    let position = 0;
    const speed = 0.7;

    const step = () => {
      const container = rowJuegosRef.current;
      if (!container) {
        animationFrameId = window.requestAnimationFrame(step);
        return;
      }

      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;

      if (scrollWidth <= clientWidth) {
        animationFrameId = window.requestAnimationFrame(step);
        return;
      }

      const contentWidth = scrollWidth / 2;
      if (contentWidth <= 0) {
        animationFrameId = window.requestAnimationFrame(step);
        return;
      }

      position += speed;
      if (position >= contentWidth) position -= contentWidth;

      container.scrollLeft = position;
      animationFrameId = window.requestAnimationFrame(step);
    };

    animationFrameId = window.requestAnimationFrame(step);

    return () => {
      if (animationFrameId) window.cancelAnimationFrame(animationFrameId);
    };
  }, [rowJuegosRef, isDesktop]);
}